module.exports = "build/fonts/arrow-right-bottom.svg";